import { render, staticRenderFns } from "./completed.vue?vue&type=template&id=b729be3c&scoped=true&"
import script from "./completed.vue?vue&type=script&lang=js&"
export * from "./completed.vue?vue&type=script&lang=js&"
import style0 from "./completed.vue?vue&type=style&index=0&id=b729be3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b729be3c",
  null
  
)

export default component.exports